import React from 'react';
export function Footer() {
  return <footer className="bg-onyx border-t border-gold/20 py-12" data-id="element-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-201">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-202">
          {/* Brand */}
          <div data-id="element-203">
            <div className="flex flex-col mb-4" data-id="element-204">
              <span className="font-cinzel text-gold text-xl tracking-widest" data-id="element-205">
                MADAM YAS
              </span>
              <div className="h-px w-32 bg-gold mt-1" data-id="element-206"></div>
            </div>
            <p className="text-silver-muted text-sm leading-relaxed mb-5" data-id="element-207">
              Professional Dominance
              <br data-id="element-208" />
              Los Angeles Area
              <br data-id="element-209" />
              Black-Owned Business
            </p>
            <a href="#tip" className="inline-flex items-center gap-2 rounded-full border border-gold/50 text-gold px-5 py-2.5 text-xs uppercase tracking-[0.2em] font-medium hover:bg-gold hover:text-ink hover:border-gold transition-all duration-300 shadow-[0_0_0_rgba(183,148,212,0)] hover:shadow-[0_0_24px_rgba(183,148,212,0.35)]" data-id="element-210">
              Leave a Tip
              <span aria-hidden className="text-base leading-none" data-id="element-211">
                ❤
              </span>
            </a>
          </div>

          {/* Quick Links */}
          <div data-id="element-212">
            <h3 className="text-bone font-cormorant text-lg mb-4" data-id="element-213">
              Quick Links
            </h3>
            <nav className="space-y-2" data-id="element-214">
              <a href="#about" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-215">
                About
              </a>
              <a href="#experiences" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-216">
                Services
              </a>
              <a href="#etiquette" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-217">
                Etiquette
              </a>
              <a href="#faq" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-218">
                FAQ
              </a>
              <a href="#contact" className="block text-silver-muted text-sm hover:text-gold transition-colors" data-id="element-219">
                Contact
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div data-id="element-220">
            <h3 className="text-bone font-cormorant text-lg mb-4" data-id="element-221">Contact</h3>
            <div className="space-y-2 text-silver-muted text-sm" data-id="element-222">
              <p data-id="element-223">
                <a href="tel:5625480191" className="hover:text-gold transition-colors" data-id="element-224">
                  562.548.0191
                </a>
              </p>
              <p data-id="element-225">
                <a href="mailto:Cinnabunnsib@gmail.com" className="hover:text-gold transition-colors break-all" data-id="element-226">
                  Cinnabunnsib@gmail.com
                </a>
              </p>
              <p className="pt-4 text-xs" data-id="element-227">
                Sessions by appointment only
                <br data-id="element-228" />
                Screening required
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gold/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-229">
          <p className="text-silver-muted text-xs" data-id="element-230">
            © {new Date().getFullYear()} Madam Yas. All rights reserved.
          </p>
          <p className="text-silver-muted text-xs" data-id="element-231">
            Discretion · Professionalism · Excellence
          </p>
        </div>
      </div>
    </footer>;
}